import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiLoader, FiAlertCircle } from 'react-icons/fi';

const SSOCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token   = params.get('token');
    const refresh = params.get('refresh');
    const err     = params.get('error');
    const msg     = params.get('message');

    if (err) {
      const labels: Record<string, string> = {
        sso_invalid_state:    'Session expirée. Veuillez réessayer.',
        sso_config_not_found: 'Configuration SSO introuvable.',
        sso_denied:           'Connexion SSO refusée par le fournisseur.',
        sso_failed:           msg || 'Échec de la connexion SSO.',
      };
      setError(labels[err] || labels['sso_failed']);
      setTimeout(() => navigate('/login'), 4000);
      return;
    }

    if (!token) {
      setError('Token manquant. Redirection vers la connexion...');
      setTimeout(() => navigate('/login'), 3000);
      return;
    }

    // Stocke les tokens (même format que le login standard)
    localStorage.setItem('token', token);
    if (refresh) localStorage.setItem('refreshToken', refresh);

    // Redirige vers le dashboard
    navigate('/dashboard', { replace: true });
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="max-w-md w-full text-center p-8">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <FiAlertCircle size={28} className="text-red-500" />
          </div>
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Erreur de connexion SSO</h2>
          <p className="text-gray-500 mb-4">{error}</p>
          <p className="text-sm text-gray-400">Redirection en cours...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <FiLoader size={32} className="animate-spin text-blue-600 mx-auto mb-4" />
        <p className="text-gray-600">Finalisation de la connexion SSO...</p>
      </div>
    </div>
  );
};

export default SSOCallbackPage;
